import workareas from "config/workareas";
import organizations from "config/organizations";

import { apiPut, apiPostFile, apiPost } from "./api";
import { workareaURLStyle } from "./workarea";
import { organizationURLStyle } from "./organization";

// Just makes sure it's an RBR file- check later in data flow that it's a solo and not another instrument
export function isSoloTxt(file) {
  return /^\s*(?:Copy of )?\d{6}_\d{8}_\d{4}(?:_eng)?(?:\s\(\d+\))?(?:\.txt)?(?:\s\d+)?$/.test(
    file.name
  );
}

export function getSoloFilename(file) {
  const searchRgx = /(\d{6}_\d{8}_\d{4})/g;
  return searchRgx.exec(file.name)[0];
}

export const handleSoloFileUpload = (file, workarea, organization, ext) => {
  const filename = getSoloFilename(file);
  return apiPostFile(
    `/solo/upload/solo/${workareaURLStyle(
      workarea
    )}/${ext}/${filename}?organization=${organizationURLStyle(organization)}`,
    file.stream(),
    { duplex: "half" }
  ).then(res => res.json());
};

export const handleSoloAnnotation = (casts, workarea) =>
  apiPost(`/solo/annotate/${workareaURLStyle(workarea)}/casts`, casts);

// Remove file from files to annotate by setting status
export const handleSoloRemoveFile = (removeFile, workarea) =>
  apiPost(`/solo/annotate/${workareaURLStyle(workarea)}/remove`, removeFile);

// Handle Solo recall
export const handleSoloRecall = (file, workarea) =>
  apiPut(`/solo/recall/solo/${workareaURLStyle(workarea)}/file`, file);

// Get the colloquial solo name from the serial number
export const getSoloPhysNum = (serial, serialMap) => {
  return serialMap[serial] || serial;
};

// Derived from config so adding a workarea/organization stays a one-file change.
// Workareas opt out (soloSupported: false); organizations opt in.
const soloUnsupportedWorkareas = workareas
  .filter(workarea => workarea.soloSupported === false)
  .map(workarea => workarea.name);

const soloSupportedOrganizations = organizations
  .filter(organization => organization.soloSupported)
  .map(organization => organization.name);

export const soloNotSupported = (workarea, organization) =>
  soloUnsupportedWorkareas.includes(workarea) ||
  !(soloSupportedOrganizations.includes(organization) || organization === null);
